/** @format */

const spain = (i18n) => [
  {
    id: "07",
    regionIdentifier: "CL",
    label: i18n.t("regions:spain.07"),
    codes: ["05", "09", "24", "34", "37", "40", "42", "47", "49"],
  },
  {
    id: "01",
    regionIdentifier: "AN",
    label: i18n.t("regions:spain.01"),
    codes: ["04", "11", "14", "18", "21", "23", "29", "41"],
  },
  {
    id: "06",
    regionIdentifier: "CM",
    label: i18n.t("regions:spain.06"),
    codes: ["02", "13", "16", "19", "45"],
  },
  {
    id: "02",
    regionIdentifier: "AR",
    label: i18n.t("regions:spain.02"),
    codes: ["22", "44", "50"],
  },
  {
    id: "09",
    regionIdentifier: "EXT",
    label: i18n.t("regions:spain.09"),
    codes: ["06", "10"],
  },
  {
    id: "08",
    regionIdentifier: "CAT",
    label: i18n.t("regions:spain.08"),
    codes: ["08", "17", "25", "43"],
  },
  {
    id: "10",
    regionIdentifier: "G",
    label: i18n.t("regions:spain.10"),
    codes: ["03", "12", "15", "27", "32", "36"],
  },
  {
    id: "15",
    regionIdentifier: "CV",
    label: i18n.t("regions:spain.15"),
    codes: ["46"],
  },
  {
    id: "14",
    regionIdentifier: "MU",
    label: i18n.t("regions:spain.14"),
    codes: ["30"],
  },
  {
    id: "03",
    regionIdentifier: "AST",
    label: i18n.t("regions:spain.03"),
    codes: ["33"],
  },
  {
    id: "16",
    regionIdentifier: "NA",
    label: i18n.t("regions:spain.16"),
    codes: ["31"],
  },
  {
    id: "13",
    regionIdentifier: "M",
    label: i18n.t("regions:spain.13"),
    codes: ["28"],
  },
  {
    id: "04",
    regionIdentifier: "IC",
    label: i18n.t("regions:spain.04"),
    codes: ["35", "38"],
  },
  {
    id: "05",
    regionIdentifier: "C",
    label: i18n.t("regions:spain.05"),
    codes: ["39"],
  },
  {
    id: "12",
    regionIdentifier: "LR",
    label: i18n.t("regions:spain.12"),
    codes: ["26"],
  },
  {
    id: "11",
    regionIdentifier: "IB",
    label: i18n.t("regions:spain.11"),
    codes: ["07"],
  },
  {
    id: "20",
    regionIdentifier: "CE/ME",
    label: i18n.t("regions:spain.20"),
    codes: ["51"],
  },
  {
    id: "17",
    regionIdentifier: "AV",
    label: i18n.t("regions:spain.17"),
    codes: ["01"],
  },
  {
    id: "18",
    regionIdentifier: "GU",
    label: i18n.t("regions:spain.18"),
    codes: ["20"],
  },
  {
    id: "19",
    regionIdentifier: "VI",
    label: i18n.t("regions:spain.19"),
    codes: ["48"],
  },
];

const spainSorted = (i18n, store) => {
  const postCode = store.state.user.postalCode;
  let sortedRegions = alphaSort(spain(i18n));
  let index;
  if (postCode && postCode !== store.state.app.unknownPostcode) {
    index = sortedRegions.findIndex(
      (region) =>
        region.codes &&
        region.codes.length > 0 &&
        region.codes.includes(postCode.substr(0, 2))
    );
    const element = sortedRegions[index];
    if (index > 0) {
      sortedRegions.splice(index, 1);
      sortedRegions.unshift(element);
    }
  }
  return sortedRegions;
};

function alphaSort(regions) {
  return [].slice.call(regions).sort((a, b) => a.label.localeCompare(b.label));
}

module.exports = {
  spain: spainSorted,
};



// WEBPACK FOOTER //
// ./src/utils/fiscal-regions.config.js